import { SeatStatus } from 'types/Location'

export const RELEASE_COLORS = {
    soldLocally: '#F2DC4E',
    soldOnline: '#F28D2B',
    selected: '#CE0000',
    reserved: '#000000',
    available: '#69707A',
    notAvailable: '#FFFFFF',
}

export const SeatColors: Record<SeatStatus, string> = {
    [SeatStatus.NotAvailable]: RELEASE_COLORS.notAvailable,
    [SeatStatus.Complimentary]: RELEASE_COLORS.reserved,
    [SeatStatus.Arrived]: RELEASE_COLORS.reserved,
    [SeatStatus.Reserved]: RELEASE_COLORS.reserved,
    [SeatStatus.InPayment]: RELEASE_COLORS.reserved,
    [SeatStatus.Sold]: RELEASE_COLORS.soldLocally,
    [SeatStatus.Selected]: RELEASE_COLORS.selected,
    [SeatStatus.Available]: RELEASE_COLORS.available,
}
